import { Button as AntButton } from "antd";
import { useFormik } from "formik";
import { t } from "i18next";
import moment from "moment";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import JordanianBuyer from "../../../../../components/JordanianBuyer";

import PageLayoutWithSidebar from "../../../../../components/PageLayoutWithSidebar";
import { configFun } from "../../../../../config";
import * as utils from "../../../../../helpers/utils";
import {
  agencyValidations,
  deputyValidations,
  getFormErrorMessage,
  guardianValidationsNew,
} from "../../../../../helpers/utils";
import {
  showError,
  updateLoading,
  updateSellingFormObject,
} from "../../../../../redux/actions";
import { getUserInfo } from "../../../../../services";
import Agency from "../../../CommonViews/OnBehalf/Agency";
import CompanyBuyer from "../../../CommonViews/OnBehalf/CompanyBuyer";
import Deputy from "../../../CommonViews/OnBehalf/Deputy";
import ForeignBuyer from "../../../CommonViews/OnBehalf/ForeignBuyer";
import Guardian from "../../../CommonViews/OnBehalf/GuardianNew";
import InputsComponent from "../../../../../components/Common/Form/InputComp";
import InputsRow from "../../../../../components/Common/Form/InputsRow";

const Creditor = (props) => {
  const { demo } = props;
  const [submitForm, setSubmitForm] = useState(false);

  const [buyerItem, setBuyerItem] = useState({});
  const [showForm, setShowForm] = useState(false);

  const dispatch = useDispatch();
  const sellingFormDetails = useSelector((state) => state.sellingFormDetails);
  const creditors = sellingFormDetails["creditorDetails"] || [];
  const sellers = sellingFormDetails["selectedShares"];
  const buyers = sellingFormDetails["buyersDetails"];

  const setBuyers = (arr) => {
    const myObj = { ...sellingFormDetails, creditorDetails: arr };
    dispatch(updateSellingFormObject(myObj));
  };

  const isExistsInSellers = (id) => {
    return sellers.find((ele) => ele.partyId === id);
  };
  const isExistsInBuyers = (id) => {
    return buyers?.find((ele) => ele.partyId === id || ele.nationalId === id);
  };

  const isDeptor = (id) => {
    return (
      sellingFormDetails.deptorsDetails?.findIndex(
        (creditor) => +creditor.nationalId === +id
      ) > -1
    );
  };
  const isDeptorAgency = (id) => {
    return (
      sellingFormDetails.deptorsDetails?.findIndex(
        (deptor) => +deptor.agentNationalId === +id
      ) > -1
    );
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      nationalId: "",
      creditors: "",
      creditorArabicName: "",
      creditorEnglishName: "",
      adjective: 1,
      creditorAge: "",
      creditorType: "jordanian",
      hasIdCard: true,
      personStatus: 0,

      personalNumber: "",
      passportNumber: "",
      passportExp: "",
      passport: "",
      name: "",
      nationality: "",
      motherName: "",
      birthDate: "",
      investApprovalNum: "",
      investApproval: "",

      isSoldier: false,
      soldireAttachment: "",

      court: {},
      isJordanianAgent: true,
      isInternalAgency: true,
      isJordanianClient: true,
      agencyNumber: "",
      attachAgency: "",
      agencyDate: "",
      agencyPlace: "",
      agentName: "",
      agencyClientName: "",
      agencyType: "",
      agencyStatus: "",
      agentNationalId: "",
      agentPersonalNumber: "",

      clientNationalId: "",
      clientPersonalNumber: "",
      isJordanianGuardian: true,
      isJordanianMinor: true,
      guardianNationalId: "",
      guardianPersonalNumber: "",
      guardianshipNumber: "",
      salesAuthorizationNumber: "",
      minorNationalId: "",
      minorPersonalNumber: "",

      guardianName: "",
      guardianshipDate: "",
      guardianshipPlace: "",
      guardianCardNo: "",
      guardianshipAttachment: "",
      salesAuthorizationDate: "",
      salesAuthorizationPlace: "",
      mortgageAuthorizationAttachment: "",
      minorName: "",

      isJordanianDeputy: true,

      entityNum: "",
      entityName: "",
      deputyNum: "",
      deputyDate: "",
      phoneNum: "",
      deputyAttach: "",
      deputyInfo: {},
      deputyNationalId: "",
      deputyPersonalNumber: "",
      deputyCardNo: "",

      entityCode: "",

      investmentApproval: "",
      neighborhood: "",
      street: "",
      address: "",
      phone: "",
    },
    validate: (data) => {
      let errors = {};
      if (data.creditorType === "jordanian") {
        if (!data.nationalId) {
          errors.nationalId = t("errors.required");
        } else if (!/^\d{10}$/g.test(data.nationalId)) {
          errors.nationalId = t("errors.nationalId10Digits");
        } else if (isDeptorAgency(data.nationalId)) {
          errors.nationalId = t("errors.creditorCantExistInDeptorAgency");
        }
        // else if (
        //   props.sellingWithMotagage &&
        //   isExistsInBuyers(data.nationalId)
        // ) {
        //   errors.nationalId = t("errors.creditorShouldNotBeBuyer");
        // }
        // else if (isExistsInSellers(data.nationalId)) {
        //   errors.nationalId = t("errors.creditorShouldNotBeOwner");
        // } else if (isDeptor(data.nationalId)) {
        //   errors.nationalId = t("errors.existsInDebtor");
        // }

        if (data.isSoldier) {
          if (!data.soldireAttachment) {
            errors.soldireAttachment = t("errors.required");
          }
          if (!data.creditorArabicName) {
            errors.creditorArabicName = t("errors.required");
          }
        } else {
          if (data.hasIdCard) {
            if (!data.creditorCardNo) {
              errors.creditorCardNo = t("errors.required");
            }
          } else if (!data.creditorBirthDate) {
            errors.creditorBirthDate = t("errors.required");
          }
        }
      } else if (data.creditorType === "foreign") {
        if (!data.nationalId) {
          errors.nationalId = t("errors.required");
        } else if (isExistsInSellers(data.nationalId)) {
          errors.nationalId = t("errors.existsInSponsors");
        } else if (isDeptor(data.nationalId)) {
          errors.nationalId = t("errors.existsInDebtor");
        }
        if (!data.passport) {
          errors.passport = t("errors.required");
        }
        if (!data.investApproval) {
          errors.investApproval = t("errors.required");
        } else if (data.investApproval !== t("common.agree")) {
          errors.investApproval = t("errors.envestmentApproval");
        }
      }
      if (data.entityCode === "5") {
        // if (
        //   !data.investmentApproval ||
        //   data.investmentApproval !== t("common.agree")
        // ) {
        //   errors.investmentApproval = t("errors.envestmentApproval");
        // }
      }
      if (data.adjective === 1) {
      } else if (data.adjective === 2) {
        // agent
        errors = { ...errors, ...agencyValidations(data) };
      } else if (data.adjective === 3 || data.adjective === 5) {
        // guardian
        errors = {
          ...errors,
          ...guardianValidationsNew(data, { isMortgage: true }),
        };
      } else if (data.adjective === 4) {
        // deputy
        errors = { ...errors, ...deputyValidations(data) };
      }
      // Add required validation for new fields
      if (!data.neighborhood) {
        errors.neighborhood = t("errors.required");
      }
      if (!data.street) {
        errors.street = t("errors.required");
      }
      if (!data.address) {
        errors.address = t("errors.required");
      }
      if (!data.phone) {
        errors.phone = t("errors.required");
      }
      return errors;
    },
    onSubmit: (data) => {
      saveChanges(data);
    },
  });
  useEffect(() => {
    if (!demo) {
      if (creditors.length < 1) {
        props.onDisableNext(true);
      } else {
        props.onDisableNext(false);
      }
    }
  }, [creditors]);

  const getBuyerAdjective = (rowData) => {
    const adjective = rowData.adjective || 1;
    return configFun().userTypesNew.find((ele) => ele.value === adjective);
    // if (
    //   rowData.creditorType === "company" ||
    //   rowData.creditorAge >= 18 ||
    //   rowData.buyerAge >= 18 ||
    //   rowData.isSoldier
    // ) {
    //   const adjective = rowData.adjective || 1;
    //   return configFun().userTypes.find((ele) => ele.value === adjective);
    // } else {
    //   return configFun().userTypes.find((ele) => ele.value === 3);
    // }
  };

  const deleteItem = (rowData) => {
    const newBuyers = creditors.filter((object) => {
      return object.nationalId !== rowData.nationalId;
    });
    setBuyers(newBuyers);
  };

  const allowedSearch = () => {
    return (
      formik.values.nationalId &&
      (formik.values.creditorCardNo ||
        moment().diff(formik.values.creditorBirthDate, "years") < 18)
    );
  };

  const editItem = (rowData) => {
    formik.setValues(rowData);
    if (!demo) {
      props.onHidePageActions(true);
    }
    setBuyerItem(rowData);
    setShowForm(true);
  };
  const cancelEdit = () => {
    setShowForm(false);
    setBuyerItem({});
    if (!demo) {
      props.onHidePageActions(false);
    }
    formik.resetForm();
  };
  const getFields = () => {
    return [
      {
        label: t("realtySelling.nationalIdOrPersonal"),
        key: "nationalId",
      },
      {
        label: t("realtySelling.personalCardIDOrPassport"),
        key: "creditorCardNo",
        body: (rowData) => {
          return rowData.creditorCardNo || "-";
        },
      },
      {
        label: t("mortgageServices.creditorName"),
        key: "creditorArabicName",
        body: (rowData) => {
          return rowData.creditorArabicName || rowData.buyerArabicName || "-";
        },
      },
      {
        label: t("mortgageServices.creditorAdjective"),
        key: "adjective",
        body: (rowData) => {
          const adjective = getBuyerAdjective(rowData);
          rowData["adjective"] = adjective.value;
          return <span className="text-danger">{adjective?.label}</span>;
        },
      },
      {
        label: "",
        key: "actions",
        body: (rowData) => {
          if (demo) {
            return (
              <AntButton
                onClick={() => editItem(rowData)}
                className="action-btn text-xs mx-1 text-sm main-button buttonWidth bg-success"
              >
                {t("common.adjectiveChange")}
              </AntButton>
            );
          }
          return rowData.nationalId === buyerItem.nationalId ? (
            <i className="pi pi-arrow-right bg-main-color text-white p-1 rounded text-sm" />
          ) : (
            <div className="d-flex">
              <Button
                icon="pi pi-trash text-danger text-sm"
                disabled={rowData.nationalId === buyerItem.nationalId || demo}
                onClick={() => deleteItem(rowData)}
                className="p-button-rounded  bg-transparent outline-none"
                aria-label="Bookmark"
              />
            </div>
          );
        },
      },
    ];
  };

  const getComponentAdjective = () => {
    switch (formik.values.adjective) {
      case 2:
        return (
          <Agency
            item={buyerItem}
            submitClick={submitForm}
            onUpdate={(value) => setBuyerItem(value)}
            editItem={buyerItem}
            formik={formik}
            buyer
            demo={demo}
            valuesNamesMapper={{
              agentInfo: "agentInfo",
              clientInfo: "clientInfo",
              agentNationalId: "agentNationalId",
              agentPersonalNumber: "agentPersonalNumber",
              firstCardNo: "agentCardNo",
              secondCardNo: "clientCardNo",
            }}
            newRepresentationsBy
          />
        );
      case 3:
      case 5:
        return (
          <Guardian
            item={buyerItem}
            submitClick={submitForm}
            onUpdate={(value) => setBuyerItem(value)}
            formik={formik}
            mortgage={true}
            demo={demo}
            valuesNamesMapper={{
              objectHolderData: "guardianNationalId",
              agentInfo: "agentInfo",
              clientInfo: "clientInfo",
              agentNationalId: "guardianNationalId",
              agentPersonalNumber: "agentPersonalNumber",
              firstCardNo: "guardianCardNo",
              secondCardNo: "minorCardNo",
              guardianCardNo: "guardianCardNo",
              guardianNationalId: "guardianNationalId",
              guardianPersonalNumber: "guardianPersonalNumber",
              guardianshipAttachment: "guardianshipAttachment",
              salesAuthorizationAttachment: "mortgageAuthorizationAttachment",
              guardianInfo: "guardianInfo",
            }}
            buyer
          />
        );
      case 4:
        return (
          <Deputy
            valuesNamesMapper={{
              agentInfo: "deputyInfo",
              agentNationalId: "deputyNationalId",
              agentPersonalNumber: "deputyPersonalNumber",
              firstCardNo: "deputyCardNo",
              secondCardNo: "clientCardNo",
            }}
            demo={demo}
            formik={formik}
          />
        );
      default:
        return null;
    }
  };

  const saveChanges = (data) => {
    setBuyers([data]);
    setBuyerItem({});
    resetForm("jordanian");
  };

  useEffect(() => {
    if (!demo) {
      if (submitForm) {
        formik.submitForm();
        setTimeout(() => {
          setSubmitForm(false);
        }, 1000);
      }
    }
  }, []);

  const getBuyerDetails = () => {
    if (
      !formik.values.nationalId ||
      (!formik.values.creditorCardNo && !formik.values.creditorBirthDate) ||
      moment().diff(formik.values.creditorBirthDate, "years") >= 18
    ) {
      return;
    }
    const isExists = creditors.find(
      (ele) => formik.values.nationalId === ele.nationalId
    );
    if (isExists) {
      dispatch(showError(t("errors.buyerexists")));
      
      return;
    }
    // if (isExistsInSellers(formik.values.nationalId)) {
    //   dispatch(showError(t("errors.creditorShouldNotBeOwner")));
    //   setTimeout(() => {
    //     dispatch(showError(""));
    //   }, 500);
    //   return;
    // }
    dispatch(updateLoading(true));
    utils.resetFetchedAgencyInfo(formik);
    getUserInfo(
      formik.values.nationalId,
      formik.values.creditorCardNo,
      false,
      formik.values.creditorBirthDate
    ).then((response) => {
      const { data } = response;
      formik.setFieldValue("personStatus", utils.getPersonStatus(data.deatH_C));
      if (data.deatH_C === 0) {
        if (moment().diff(moment(data.birthdt), "years") < 18) {
          dispatch(showError(t("errors.cantChooseMinor")));
          
          // formik.setFieldValue("adjective", 3);
        } else {
          const { arName, enName } = utils.getUserName(data);
          formik.setFieldValue("creditorArabicName", arName);
          formik.setFieldValue("creditorEnglishName", enName);
          formik.setFieldValue(
            "creditorAge",
            moment().diff(moment(data.birthdt), "years")
          );
        }
      } else {
        dispatch(
          showError(t("errors.buyerMustBeAlive", { buyer: t("errors.buyer") }))
        );
        
      }
    });
  };

  const resetForm = async (value) => {
    await formik.resetForm();
    formik.setFieldValue("creditorCardNo", "");
    formik.setFieldValue("creditorType", value);
  };

  const resetHasIdCardFields = () => {
    formik.setFieldValue("creditorCardNo", "");
    formik.setFieldValue("creditorArabicName", "");
    formik.setFieldValue("creditorBirthDate", "");
  };
  return (
    <React.Fragment>
      {(!!!creditors.length || showForm) && (
        <PageLayoutWithSidebar className="mt-4">
          <div className="d-flex justify-content-between">
            <p className="fm-kufi-bold text-sm">
              {t("mortgageServices.creditor")}
            </p>
          </div>
          <form disabled onSubmit={formik.handleSubmit}>
            <div className="row my-3">
              <div className="col-sm-3 col-12">
                <RadioButton
                  value="jordanian"
                  checked={formik.values.creditorType === "jordanian"}
                  name="creditorType"
                  onChange={(e) => {
                    formik.setFieldValue("creditorType", e.value);
                    resetForm(e.value);
                  }}
                  disabled={creditors.length || demo}
                />
                <label className="block text-sm fm-kufi-regular text-form-label">
                  {t("realtySelling.jordanian")}
                </label>
              </div>
              <div className="col-sm-3 col-12">
                <RadioButton
                  value="foreign"
                  checked={formik.values.creditorType === "foreign"}
                  name="creditorType"
                  onChange={(e) => {
                    formik.setFieldValue("creditorType", e.value);
                    resetForm(e.value);
                  }}
                  disabled={creditors.length || demo}
                />
                <label className="block text-sm fm-kufi-regular text-form-label">
                  {t("realtySelling.forigen")}
                </label>
              </div>
              <div className="col-sm-3 col-12">
                <RadioButton
                  value="company"
                  checked={formik.values.creditorType === "company"}
                  name="creditorType"
                  onChange={(e) => {
                    formik.setFieldValue("creditorType", e.value);
                    resetForm(e.value);
                  }}
                  disabled={
                    formik.values.creditorType === "company" ||
                    creditors.length ||
                    demo
                  }
                />
                <label className="block text-sm fm-kufi-regular text-form-label">
                  {t("realtySelling.company")}
                </label>
              </div>
            </div>
            <div className="row">
              {formik.values.creditorType === "jordanian" && (
                <JordanianBuyer
                  formik={formik}
                  demo={props.demo}
                  sellers={sellers}
                  buyers={creditors}
                  hasIdtTitle={t("mortgageServices.hasIdCard")}
                  buyerName={t("mortgageServices.creditorName")}
                  withoutExemption
                  doNotCheckOnBuyerExistInSellers
                  errorIfMinor
                  keyMapper={{
                    buyerCardNo: "creditorCardNo",
                    buyerArabicName: "creditorArabicName",
                    buyerBirthDate: "creditorBirthDate",
                    nationalId: "nationalId",
                    buyerEnglishName: "creditorEnglishName",
                    card_expiry: "card_expiry",
                    card_no: "card_no",
                    card_issuer: "card_issuer",
                    buyerAge: "creditorAge",
                    adjective: "adjective",
                    exemption: "exemption",
                    appDate: "appDate",
                    hasIdCard: "hasIdCard",
                    isSoldier: "isSoldier",
                  }}
                />
              )}
              {formik.values.creditorType === "foreign" && (
                <ForeignBuyer
                  formik={formik}
                  demo={demo}
                  // noInvestApproval
                  // noPassport
                  keyMapper={{
                    personalNumber: "nationalId",
                    passportNumber: "creditorCardNo",
                    name: "creditorArabicName",
                    nationality: "nationality",
                    motherName: "motherName",
                    birthDate: "birthDate",
                    investApprovalNum: "investApprovalNum",
                    investApproval: "investApproval",
                  }}
                />
              )}

              {formik.values.creditorType === "company" && (
                <CompanyBuyer formik={formik} demo={demo} noInvestApproval />
              )}
              <InputsRow>
                <InputsComponent
                  title={t("mortgageServices.neighborhood")}
                  required
                  name="neighborhood"
                  value={formik.values.neighborhood}
                  onChange={formik.handleChange}
                  formik={formik}
                  disabled={demo}
                />
                <InputsComponent
                  title={t("mortgageServices.street")}
                  required
                  name="street"
                  value={formik.values.street}
                  onChange={formik.handleChange}
                  formik={formik}
                  disabled={demo}
                />
                <InputsComponent
                  title={t("mortgageServices.address")}
                  required
                  name="address"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  formik={formik}
                  disabled={demo}
                />
                <InputsComponent
                  title={t("mortgageServices.phone")}
                  required
                  name="phone"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  formik={formik}
                  disabled={demo}
                />
              </InputsRow>
              <div className="row">
                <div className="col-lg-3 col-sm-6 mb-4 form-inputs">
                  <label className="block text-xs fm-kufi-regular text-form-label">
                    {t("mortgageServices.creditorAdjective")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div>
                    <Dropdown
                      className="mt-2 w-100"
                      value={formik.values.adjective}
                      onChange={(e) => {
                        utils.resetAdjective(formik);
                        formik.handleChange(e);
                      }}
                      options={utils.getUserTypesByBuyerType(
                        // configFun().userTypesNew.filter(
                        //   (type) => !(type.value === 3 || type.value === 5)
                        // ),
                        configFun().userTypesNew,
                        formik.values.creditorType === "company",
                        formik.values.isSoldier,
                        formik.values.creditorAge || formik.values.buyerAge
                      )}
                      // options={
                      //   formik.values.creditorType !== "company"
                      //     ? configFun().userTypes.slice(0, 3)
                      //     : configFun().userTypes
                      // }
                      optionLabel="label"
                      optionValue="value"
                      name="adjective"
                      disabled={
                        formik.values.creditorType === "company" || demo
                      }
                    />
                    {getFormErrorMessage(formik, "adjective")}
                  </div>
                </div>
              </div>
            </div>

            {getComponentAdjective()}

            <div className="row gap-3 justify-content-center my-4 submit-action">
              <Button
                type="submit"
                label={t("common.save")}
                onClick={() => setSubmitForm(true)}
                style={{ minWidth: "max-content" }}
                disabled={
                  !formik.isValid ||
                  !(
                    formik.values.creditorArabicName ||
                    formik.values.buyerArabicName
                  ) ||
                  creditors.length ||
                  demo
                }
                className="action-btn col-lg-2 col-sm-4 d-block h-fit submit-btn py-2 text-xs fm-kufi-regular text-sm"
              />
              {demo && (
                <Button
                  onClick={cancelEdit}
                  className="action-btn col-lg-2 d-block col-sm-4 h-fit py-2 text-xs back-btn mx-2 fm-kufi-regular text-sm"
                >
                  {t("common.cancel")}
                </Button>
              )}
            </div>
          </form>
        </PageLayoutWithSidebar>
      )}

      {!!creditors.length && (
        <PageLayoutWithSidebar className="mt-4">
          <p className="fm-kufi-bold text-sm">
            {t("mortgageServices.creditor")}
          </p>
          <DataTable
            emptyMessage={t("common.noResultsFound")}
            className="realty-table fm-kufi-regular"
            tableClassName="w-100"
            value={creditors}
            responsiveLayout="scroll"
          >
            {getFields().map((item) => (
              <Column
                key={item.key}
                field={item.key}
                header={item.label}
                body={item.body ? item.body : null}
              />
            ))}
          </DataTable>
        </PageLayoutWithSidebar>
      )}
    </React.Fragment>
  );
};

export default Creditor;
